import { AxiosRequestConfig } from "axios";
import { AuthResponse } from "./models";
import jwt from 'jsonwebtoken';
import {refresh} from '.';
import Permissions from './permissions';
import { setTimer } from "../../utils/logoutTimer";
  
export class TokenStorage {

    private static readonly LOCAL_STORAGE_TOKEN = 'token';
    private static readonly LOCAL_STORAGE_REFRESH_TOKEN = 'refresh_token';
    private static readonly LOCAL_STORAGE_RESET_TOKEN = 'reset_token';
    private static modules: string[] | undefined = undefined

     public static getUserName () {
        const tokens = this.getTokens();
        if (!tokens) {
            return "";
        }
        const {accessToken} = tokens;

        if (accessToken && jwt.decode(accessToken)) {
            const decodedToken: any = jwt.decode(accessToken, {complete: true});

            if (decodedToken.payload.username){
                let userName: String = decodedToken.payload.username
                return userName
            }
        }
        return ""
    }

    public static getCustomerId () {
        const tokens = this.getTokens();
        if (!tokens) {
            return "";
        }
        const {accessToken} = tokens;

        if (accessToken && jwt.decode(accessToken)) {
            const decodedToken: any = jwt.decode(accessToken, {complete: true});

            if (decodedToken.payload.customerId){
                let customerId = decodedToken.payload.customerId
                return customerId
            }
        }
        return ""
    }

    public static getModuleAccesses() {
        if (TokenStorage.modules) {
            return TokenStorage.modules;
        }
        const tokens = this.getTokens();
        var res: string[] = []
        if (!tokens) {
            return res;
        }

        const {accessToken} = tokens;
        if (accessToken && jwt.decode(accessToken)) {
            const decodedToken: any = jwt.decode(accessToken, {complete: true});

            if (decodedToken.payload.mobilbase) {
                res.push(Permissions.Mobilbase)
            }
            if (decodedToken.payload.globalSearch) {
                res.push(Permissions.GlobalSearch)
            }
            if (decodedToken.payload.infomodul) {
                res.push(Permissions.InfoModule)
            }
            if (decodedToken.payload.permissionUserManagement) {
                res.push(Permissions.UserManagement)
            }
            if (decodedToken.payload.permissionStatistics) {
                res.push(Permissions.Statistics)
            }
            if (decodedToken.payload.permissionDoorOpener) {
                res.push(Permissions.SMSDoorOpener)
            }
            if (decodedToken.payload.permissionAlarms) {
                res.push(Permissions.Alarms)
            }
            if (decodedToken.payload.permissionDigitalLicenses) {
                res.push(Permissions.DigitalLicenses)
            }
            if (decodedToken.payload.permissionCustomerManagement) {
                res.push(Permissions.CustomerManagement)
            }
        }
        return res;
    }

    private static setLogoutTimer = setTimer()
    public static updateLoginTimer(){
          TokenStorage.setLogoutTimer = setTimer()   
    }

    public static async isAuthenticated(): Promise<boolean> {
        const tokens = this.getTokens();
        if (!tokens) {
            this.clear();
            return false;
        }

        const {accessToken, refreshToken} = tokens;
        if (accessToken && jwt.decode(accessToken)) {
            const decodedToken: any = jwt.decode(accessToken, {complete: true});
            const expiry = (decodedToken.payload.exp) * 1000;
            const now = new Date();
            const logoutTime = TokenStorage.setLogoutTimer

            if (now.getTime() > logoutTime.getTime()){
                this.clear()
                window.alert("Session has been too long, login again to continue")
               // returnToLoginPage()
                window.location.href = 'src\pages\Login\index.tsx'
                return false
            }
            if (now.getTime() < expiry) {
                return true
            } 
            else if (refreshToken) {
                const refreshRes = await refresh(tokens)
            if (refreshRes) {
                return true
            }
            }
        }
        this.clear();
        return false;
    }

    public static getAuthentication(): AxiosRequestConfig {
        return {
            headers: { 'Authorization': 'Bearer ' + this.getToken() }
        };
    }

    public static storeTokens(tokens: AuthResponse) {
        this.storeToken(tokens.accessToken);
        this.storeRefreshToken(tokens.refreshToken);
    }

    public static storeResetPassToken(token : any) {
        this.storeResetToken(token);
    }

    public static getResetPassToken(): string | null {
        const reToken = this.getResetToken();

        if (!reToken) {
            return null;
        }

        return reToken;
    }

    public static getTokens(): AuthResponse | null {
        const aToken = this.getToken();
        const rToken = this.getRefreshToken();

        if (!aToken || !rToken) {
            return null;
        }

        return { accessToken: this.getToken() as string, refreshToken: this.getRefreshToken() as string};
    }

    private static storeToken(token: string) {
        localStorage.setItem(TokenStorage.LOCAL_STORAGE_TOKEN, token);
      }

    private static storeRefreshToken(refreshToken: string) {
        localStorage.setItem(TokenStorage.LOCAL_STORAGE_REFRESH_TOKEN, refreshToken);
    }

    private static storeResetToken(resetToken: string) {
        localStorage.setItem(TokenStorage.LOCAL_STORAGE_RESET_TOKEN, resetToken);
    }

    public static clear() {
        TokenStorage.modules = undefined;
        localStorage.removeItem(TokenStorage.LOCAL_STORAGE_TOKEN);
        localStorage.removeItem(TokenStorage.LOCAL_STORAGE_REFRESH_TOKEN);
    }

    public static clearResetToken() {
        localStorage.removeItem(TokenStorage.LOCAL_STORAGE_RESET_TOKEN);
    }

    private static getRefreshToken(): string | null {
        return localStorage.getItem(TokenStorage.LOCAL_STORAGE_REFRESH_TOKEN);
    }

    private static getToken(): string | null {
        return localStorage.getItem(TokenStorage.LOCAL_STORAGE_TOKEN);
    }

    private static getResetToken(): string | null {
        return localStorage.getItem(TokenStorage.LOCAL_STORAGE_RESET_TOKEN);
    }
}